module.exports = __webpack_public_path__ + "img/pic_chanpintedian@2x.afda5081.png";